export default __webpack_public_path__ + "static/media/error-circle.5a767d9a.svg";